import type { App } from 'vue';
import { delivery } from './delivery';
import { DeliveryKey } from '@/types/symbols';

const deliveryPlugin = {
	install: (app: App) => app.provide(DeliveryKey, delivery)
};

export { delivery, deliveryPlugin };
